module.exports = __webpack_public_path__ + "static/media/XXIIIe.ee125f82.png";